import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _JSXStyle from "styled-jsx/style";
import { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { idFromPrefix } from '@@client/lib/forms';
import { useTokenCache } from '@@client/lib/hooks';
import { addNotificationSuccess } from '@@client/notification/actions';
import PrivacyTermsBrief from '@@client/components/PrivacyTermsBrief';
import Modal from '@@client/components/Modal';
import Messages from '@@client/components/Messages';
import { newsletterSignup, newsletterSignupClear } from './actions';
import NewsletterForm from './NewsletterForm';

var mapStateToProps = function mapStateToProps(_ref) {
  var config = _ref.config,
      newsletter = _ref.newsletter;
  return {
    config: config,
    newsletter: newsletter
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      addNotificationSuccess: addNotificationSuccess,
      newsletterSignup: newsletterSignup,
      newsletterSignupClear: newsletterSignupClear
    }, dispatch)
  };
};

var NewsletterModal = function NewsletterModal(_ref2) {
  var config = _ref2.config,
      newsletter = _ref2.newsletter,
      isOpen = _ref2.isOpen,
      actions = _ref2.actions,
      _ref2$onClose = _ref2.onClose,
      onClose = _ref2$onClose === void 0 ? function () {} : _ref2$onClose;
  var tokenCache = useTokenCache();
  useEffect(function () {
    actions.newsletterSignupClear();
  }, [isOpen]);
  var idPrefix = 'newsletter-modal';

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
      var name, email, success;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              name = _ref3.name, email = _ref3.email;
              _context.next = 3;
              return actions.newsletterSignup(tokenCache, {
                name: name,
                email: email
              });

            case 3:
              success = _context.sent;

              if (success) {
                actions.addNotificationSuccess("You're signed up for our newsletter.");
                onClose();
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var renderModalContent = function renderModalContent() {
    if (!config.message.newsletterSignupEnabled) {
      return /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("em", {
          children: "Newsletter sign-up is not currently available. Please check back later."
        })
      });
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Messages, {
        error: newsletter.errors
      }), /*#__PURE__*/_jsx(NewsletterForm, {
        idPrefix: idPrefix,
        disabled: newsletter.doing,
        paramErrors: newsletter.paramErrors,
        onSubmit: handleSubmit,
        includeLabels: true
      }), /*#__PURE__*/_jsx(PrivacyTermsBrief, {
        className: "m--center"
      })]
    });
  };

  return /*#__PURE__*/_jsxs(Modal, {
    initialFocus: '#' + idFromPrefix(idPrefix, 'name'),
    isOpen: isOpen,
    onClose: onClose,
    title: "Sign up for our newsletter",
    subtitle: "Stay up-to-date with our latest offerings and deals.",
    children: [/*#__PURE__*/_jsx("div", {
      className: "jsx-2324193191" + " " + 'container',
      children: renderModalContent()
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2324193191",
      children: [".container.jsx-2324193191 .actions{text-align:center;}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsletterModal);